var _defs, _g, _path, _path2, _path3, _g2, _g3, _g4, _g5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    zoomAndPan: "magnify",
    viewBox: "0 0 33.75 33.749998",
    height: 45,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9bd34866c5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 33.5 0 L 33.5 33.5 L 0 33.5 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a8dace38b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 33.5 0 L 33.5 3.351562 L 0 3.351562 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "061d95a07c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 3.351562 0 L 3.351562 33.5 L 0 33.5 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a2d5f5242c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 30.152344 L 33.5 30.152344 L 33.5 33.5 L 0 33.5 Z M 0 30.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7267b2c1f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.152344 0 L 33.5 0 L 33.5 33.5 L 30.152344 33.5 Z M 30.152344 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9bd34866c5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 5.164062 0.511719 L 28.429688 0.511719 C 30.988281 0.511719 33.082031 2.605469 33.082031 5.164062 L 33.082031 28.429688 C 33.082031 30.988281 30.988281 33.082031 28.429688 33.082031 L 5.164062 33.082031 C 2.605469 33.082031 0.511719 30.988281 0.511719 28.429688 L 0.511719 5.164062 C 0.511719 2.605469 2.605469 0.511719 5.164062 0.511719 Z M 5.164062 0.511719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.960938 9.46875 C 22.261719 9.46875 21.566406 10.046875 21.566406 10.863281 C 21.566406 11.675781 22.148438 12.257812 22.960938 12.257812 C 23.773438 12.257812 24.355469 11.675781 24.355469 10.863281 C 24.242188 10.046875 23.660156 9.46875 22.960938 9.46875 Z M 22.960938 9.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 16.796875 11.210938 C 13.65625 11.210938 11.09375 13.769531 11.09375 16.910156 C 11.09375 20.050781 13.65625 22.613281 16.796875 22.613281 C 19.9375 22.613281 22.496094 20.050781 22.496094 16.910156 C 22.613281 13.769531 20.050781 11.210938 16.796875 11.210938 Z M 16.796875 20.632812 C 14.816406 20.632812 13.074219 19.003906 13.074219 16.910156 C 13.074219 14.933594 14.703125 13.191406 16.796875 13.191406 C 18.773438 13.191406 20.519531 14.816406 20.519531 16.910156 C 20.519531 19.003906 18.890625 20.632812 16.796875 20.632812 Z M 16.796875 20.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.449219 5.164062 L 12.140625 5.164062 C 8.304688 5.164062 5.164062 8.304688 5.164062 12.140625 L 5.164062 21.449219 C 5.164062 25.289062 8.304688 28.429688 12.140625 28.429688 L 21.449219 28.429688 C 25.289062 28.429688 28.429688 25.289062 28.429688 21.449219 L 28.429688 12.140625 C 28.429688 8.304688 25.289062 5.164062 21.449219 5.164062 Z M 26.21875 21.449219 C 26.21875 24.125 24.007812 26.21875 21.449219 26.21875 L 12.140625 26.21875 C 9.46875 26.21875 7.375 24.007812 7.375 21.449219 L 7.375 12.140625 C 7.375 9.46875 9.582031 7.375 12.140625 7.375 L 21.449219 7.375 C 24.125 7.375 26.21875 9.582031 26.21875 12.140625 Z M 26.21875 21.449219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a8dace38b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M -3.609375 -3.125 L 33.757812 -3.125 L 33.757812 3.351562 L -3.609375 3.351562 Z M -3.609375 -3.125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#061d95a07c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M -1.824219 0 L 3.351562 0 L 3.351562 36.5625 L -1.824219 36.5625 Z M -1.824219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a2d5f5242c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0 30.152344 L 36.542969 30.152344 L 36.542969 35.214844 L 0 35.214844 Z M 0 30.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7267b2c1f3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 30.152344 -3.125 L 37.375 -3.125 L 37.375 33.488281 L 30.152344 33.488281 Z M 30.152344 -3.125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c96b2a500c546cbd11761ebbb0aec0ab.svg";
export { ForwardRef as ReactComponent };